import { SideBarItems } from '../shared';
import gameKit from '../../GameKit';

export function activateSidebar() {
    return { type: 'ACTIVATE_SIDEBAR' };
}

export function setActiveSidebarItem(item) {
    switch (item) {
        case SideBarItems.BLOK_EDITOR:
            gameKit.levelEditor.blokEditor.switchToActieReactieMode(false);
            gameKit.levelEditor.blokEditor.setSelectedBlokState(0);
            break;
        case SideBarItems.ACTION_REACTION:
            gameKit.levelEditor.blokEditor.setSelectedBlokState(0);
            gameKit.levelEditor.blokEditor.switchToActieReactieMode(true);
            break;
        case SideBarItems.BLOK_CHANGE_STATE:
            gameKit.levelEditor.blokEditor.switchToActieReactieMode(false);
            gameKit.levelEditor.blokEditor.setSelectedBlokState(1);
            break;
        default:
            break;
    }

    return { type: 'SET_ACTIVE_SIDEBAR_ITEM', payload: item };
}
